import React from 'react';
import {
  LuMail,
  LuPhone,
  LuShield,
  LuFileText,
  LuPencil,
  LuTrash2,
  LuDownload,
} from 'react-icons/lu';
import { getAssetTypeLabel } from '../config/nomineeForm';

function formatDisplayName(nominee) {
  if (nominee?.nomineeName?.trim()) return nominee.nomineeName.trim();
  if (!nominee?.nomineeEmail) return 'Nominee';
  const local = nominee.nomineeEmail.split('@')[0] || nominee.nomineeEmail;
  return local
    .replace(/[._-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

function NomineeCard({ nominee, onEdit, onRemove, onViewDocument }) {
  const displayName = formatDisplayName(nominee);
  const assetLabel = nominee.assetType ? getAssetTypeLabel(nominee.assetType) : 'Asset';
  const documentLabel = nominee.documentFileName
    || (nominee.providerName ? `${nominee.providerName} document` : 'Document');

  return (
    <article className="nc-card">
      <header className="nc-header">
        <div className="nc-status">
          <span className="nc-status-dot" aria-hidden="true" />
          Verified
        </div>

        <div className="nc-header-actions">
          <button
            type="button"
            className="nc-action-btn"
            aria-label="Edit nominee"
            title="Edit"
            onClick={() => onEdit(nominee)}
          >
            <LuPencil aria-hidden="true" />
            <span className="nc-action-label">Edit</span>
          </button>
          <button
            type="button"
            className="nc-action-btn nc-action-btn--danger"
            aria-label="Delete nominee"
            title="Delete"
            onClick={() => onRemove(nominee.nomineeId, nominee.policyId)}
          >
            <LuTrash2 aria-hidden="true" />
            <span className="nc-action-label">Delete</span>
          </button>
        </div>
      </header>

      <div className="nc-identity">
        <h4 className="nc-name">{displayName}</h4>
        <p className="nc-provider">
          <LuShield aria-hidden="true" />
          <span>{nominee.providerName || 'Provider not set'}</span>
        </p>
        <p className="nc-asset-meta">
          {assetLabel}
          {nominee.policyNumber ? ` · ${nominee.policyNumber}` : ''}
        </p>
      </div>

      <ul className="nc-details">
        <li className="nc-detail">
          <LuMail aria-hidden="true" />
          <div className="nc-detail-body">
            <span className="nc-detail-label">Email</span>
            {nominee.nomineeEmail ? (
              <a className="nc-detail-value" href={`mailto:${nominee.nomineeEmail}`}>
                {nominee.nomineeEmail}
              </a>
            ) : (
              <span className="nc-detail-value nc-detail-value--muted">Not provided</span>
            )}
          </div>
        </li>
        <li className="nc-detail">
          <LuPhone aria-hidden="true" />
          <div className="nc-detail-body">
            <span className="nc-detail-label">Phone</span>
            <span className="nc-detail-value">{nominee.nomineePhone || 'Not provided'}</span>
          </div>
        </li>
      </ul>

      <div className="nc-document">
        <div className="nc-document-row">
          <div className="nc-document-icon" aria-hidden="true">
            <LuFileText />
          </div>
          <div className="nc-document-meta">
            {nominee.hasDocument ? (
              <>
                <span className="nc-document-title">{documentLabel}</span>
                <span className="nc-document-type">PDF / Image</span>
              </>
            ) : (
              <>
                <span className="nc-document-title">No document attached</span>
                <span className="nc-document-type">Upload a document</span>
              </>
            )}
          </div>
        </div>

        {nominee.hasDocument ? (
          <button
            type="button"
            className="nc-view-doc-btn"
            onClick={(event) => onViewDocument(event, nominee)}
          >
            <LuDownload aria-hidden="true" />
            View document
          </button>
        ) : (
          <button
            type="button"
            className="nc-view-doc-btn nc-view-doc-btn--muted"
            onClick={() => onEdit(nominee)}
          >
            Add document
          </button>
        )}
      </div>
    </article>
  );
}

export default NomineeCard;
